import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.home.actions';

import { AssignedIcon, VenueIcon, BlueRightArrowIcon } from '../../../images/icons/WrapSvg';

class Index extends React.Component {
    handleClick = (e) => {
        const { primary, data, history } = this.props;
        history.push(history.location.pathname + '/' + (primary ? data.id : data.codigo));
    };

    render() {
        const { data, last } = this.props;
        const {
            nombre,
            instanciasesperandopormi,
            instanciastotales,
            instanciasvencidas,
            instanciascerradas,
            modificado,
            instanciasactivas,
        } = data;
        return (
            <div
                onClick={this.handleClick}
                className={classNames(
                    'hand flex_full_column margin_top_9 margin_left_24 ',
                    last ? 'noshadow' : 'shadow_down',
                )}
            >
                <div className={'flex_auto_column padding_bottom_9'}>
                    <div className={'margin_bottom_5 flex_full_row'}>
                        <span className={'barlow_medium c_dark_grey_blue upper'}>{nombre}</span>
                    </div>
                </div>
                <div className={'flex_full_row padding_bottom_9 align_center'}>
                    <div className={'flex_full_column height100'}>
                        <div className={'flex_full_row margin_top_8'}>
                            <div className={'check_icon_text_div'}>
                                <AssignedIcon color="primary" />
                                <span className={'barlowcondensed_regular_number c_grey_blue'}>
                                    {instanciasesperandopormi}
                                </span>
                            </div>
                            <div className={'check_icon_text_div'}>
                                <VenueIcon color="primary" />
                                <span className={'barlowcondensed_regular_number c_grey_blue'}>
                                    {instanciastotales}
                                </span>
                            </div>
                            <div className={'check_icon_text_div'}>
                                <div className={'dot18 cerrada margin_right_6'} />
                                <span className={'barlowcondensed_regular_number c_grey_blue'}>
                                    {instanciascerradas}
                                </span>
                            </div>
                        </div>
                        <div
                            className={classNames(
                                'flex_full_row align_botton',
                                'barlow_regular_small c_grey_blue',
                            )}
                        >
                            <FormattedMessage id="checks_date_message" />
                            <span>{modificado && modificado.substr(0, 16).replace('T', ' ')}</span>
                        </div>
                    </div>
                    <div
                        className={classNames(
                            'flex_normal_column  center padding_left_6',
                            'check_labels_number',
                        )}
                    >
                        <span className={'barlowcondensed_summary_number c_pea text_align_center'}>
                            {instanciasactivas}
                        </span>
                        <FormattedMessage id="checks_active_message" />
                    </div>
                    <div
                        className={classNames(
                            'flex_normal_column center padding_left_6',
                            'check_labels_number',
                        )}
                    >
                        <span
                            className={
                                'barlowcondensed_summary_number c_lipstick text_align_center'
                            }
                        >
                            {instanciasvencidas}
                        </span>
                        <FormattedMessage id="checks_expired_message" />
                    </div>
                    <div className={'flex_normal_column elements_center padding_left_6'}>
                        <BlueRightArrowIcon color="primary" />
                    </div>
                </div>
            </div>
        );
    }
}

Index.propTypes = {
    history: PropTypes.object.isRequired,
};
Index = withRouter(Index);

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

Index = connect(
    null,
    mapDispatchToProps,
)(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/families/Check.js